export const state = () => ({
  patient_list: {},
  percentage_consultation: {
    success: 0,
    doctor_failed: 0,
    patient_failed: 0
  },
  percentage_rating: {
    RateFive: 0,
    RateFour: 0,
    RateOne: 0,
    RateThree: 0,
    RateTwo: 0,
    RateZero: 0,
    TotalRate: 0,
    NotRate: 0,
    SuccessPractice: 0
  }
})

export const mutations = {
  SET_PATIENT_LIST: (state, data) => {
    state.patient_list = data
  },
  SET_PERCENTAGE_CONSULTATION: (state, data) => {
    state.percentage_consultation = data
  },
  SET_PERCENTAGE_RATING: (state, data) => {
    state.percentage_rating = data
  }
}

export const actions = {
  getAllPatientList ({ commit }, data) {
    const { limit, page, current, keyword, token } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/consultation/1601485200/${current}?limit=${limit}&page=${page}&keyword=${keyword}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data.Data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getPatientList ({ commit }, data) {
    const { limit, page, keyword, token, date_start, date_end } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/consultation/${date_start}/${date_end}?limit=${limit}&page=${page}&keyword=${keyword}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data.Data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getCommisionData ({ commit }, data) {
    const { token, date_start } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `doctor/income?From=${date_start}`, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getHistoryIncome ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { page, per_page } = payload
      this.$api.get(`doctor/income/history?perpage=${per_page}&page=${page}`)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  setPercentageConsultation ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PERCENTAGE_CONSULTATION', data)
    })
  },

  setPercentageRating ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PERCENTAGE_RATING', data)
    })
  }
}
